import { ColorContext } from 'App';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaPause, FaPlay } from 'react-icons/fa';
import { getAudioFile } from 'services/devices/devices.service';

const AudioPreview = ({
  type,
  tone,
  roadStatus,
  setRoadStatus,
  playButtonOverride,
  pauseButtonOverride,
  update,
}) => {
  const theme = useContext(ColorContext);
  const audioRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [audioValid, setAudioValid] = useState(false);

  useEffect(() => {
    let currentAudio = null;
    let blobUrl = null;

    async function getAudio() {
      try {
        if (!tone?.id) throw new Error('Missing tone id');
        const response = await getAudioFile(tone.id);

        // response.data is already a Blob when responseType: 'blob' is set
        blobUrl = URL.createObjectURL(response.data);

        currentAudio = new Audio(blobUrl);
        currentAudio.onended = () => setIsPlaying(false);
        currentAudio.onerror = (e) => {
          console.error('Audio playback error:', e);
          setAudioValid(false);
          audioRef.current = null;
        };

        audioRef.current = currentAudio;
        setAudioValid(true);
      } catch (err) {
        console.error('Error getting Audio playback file:', err);
        setAudioValid(false);
        audioRef.current = null;
      }
    }

    getAudio();

    // stop old audio when tone/update changes
    return () => {
      try {
        if (audioRef.current) {
          audioRef.current.pause();
        }
        if (blobUrl) {
          URL.revokeObjectURL(blobUrl);
        }
      } catch {}
      audioRef.current = null;
      setIsPlaying(false);
    };
  }, [tone, update]);

  const playTone = () => {
    if (!audioRef.current) return;
    try {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current
          .play()
          .then(() => setIsPlaying(true))
          .catch((error) => console.error('Error playing audio:', error));
      }
    } catch (error) {
      console.error('Error handling audio playback:', error);
    }
  };

  return (
    <button
      disabled={!audioValid}
      className="btn btn-primary p-2"
      onClick={() => {
        playTone();
      }}
    >
      {isPlaying ? (
        <>
          {!pauseButtonOverride && (
            <div className="d-flex gap-2">
              <div>
                <FaPause />
              </div>
              <p>Preview</p>
            </div>
          )}

          {pauseButtonOverride}
        </>
      ) : (
        <>
          {!playButtonOverride && (
            <div className="d-flex gap-2">
              <div>
                <FaPlay />
              </div>
              <div>Preview</div>
            </div>
          )}

          {playButtonOverride}
        </>
      )}
    </button>
  );
};

export default AudioPreview;
